export default "__VITE_ASSET__BNueq0qs__"